module.exports = __webpack_public_path__ + "static/img/image.b900f517.jpg";